// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__U53wf","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__20g1e"};